import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/partners/directory/#webpage",
   "url": "https://www.futurefamilyai.com/partners/directory/",
   "name": "IVF Clinic & Surrogacy Agency Directory | FutureFamilyAI",
   "description": "A no-fee directory of participating IVF clinics, surrogacy agencies and clinicians. Find partners or list your organization free.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Partner Directory",
     "item": "https://www.futurefamilyai.com/partners/directory/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "How do I find a surrogacy agency or IVF clinic near me?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Use the directory search to filter by service and state, then contact providers directly and verify credentials."
     }
    },
    {
     "@type": "Question",
     "name": "Is the directory free?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. Listing is free for verified partners and searching is free for families."
     }
    },
    {
     "@type": "Question",
     "name": "Does a listing mean FutureFamilyAI endorses the provider?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. Listing means the provider met our published criteria; it is not an endorsement of outcomes."
     }
    },
    {
     "@type": "Question",
     "name": "Are affiliated brands listed?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, and they are clearly labeled as affiliated with the Surrogacy4All network."
     }
    },
    {
     "@type": "Question",
     "name": "How are providers ordered?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "By published, non-paid criteria such as service match and location."
     }
    },
    {
     "@type": "Question",
     "name": "How do I join?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Complete the partner application; we verify credentials before publishing your listing."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function PartnersDirectoryPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <span>Partner Directory</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                The FutureFamilyAI Partner Directory lists participating IVF
                clinics, surrogacy agencies and clinicians that support patients
                using the app.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Referring providers; families seeking providers</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Assisted reproductive technology contributes to roughly 2%
                      of U.S. births each year. (CDC ART Surveillance)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      Free for partners · Verified listings with published
                      criteria · Transparent — no paid ranking
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">PILLAR GUIDE · PARTNER NETWORK</span>
            <h1>IVF Clinic and Surrogacy Agency Directory — No Fees</h1>
            <p className="ffh-answer speakable-content">
              The FutureFamilyAI Partner Directory lists participating IVF
              clinics, surrogacy agencies and clinicians that support patients
              using the app. Listing is free for verified partners, and families
              can search by service and location. Inclusion is not an
              endorsement of outcomes, so always verify credentials directly.
              Families can filter by service and state in seconds. Join the
              network or find a provider.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/partners/join-referral-network"
              >
                Join the Partner Network — No Fees
              </Link>
              <Link
                className="ffh-btn ffh-ghost"
                to="/contact-us?type=physician"
              >
                Request a Clinical Demo
              </Link>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Searching the FutureFamilyAI partner directory for fertility providers"
              >
                <figcaption>
                  <b>Photo slot</b> · Overhead photo of a desk with a laptop
                  showing a blurred map-style interface, a coffee cup and a
                  notebook; neutral, professional. No readable text.
                  <br />
                  <b>Alt:</b> Searching the FutureFamilyAI partner directory for
                  fertility providers
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Assisted reproductive technology contributes to roughly 2%
                    of U.S. births each year.
                    <cite>
                      Source:{" "}
                      <a href="https://www.cdc.gov/art/">
                        CDC ART Surveillance
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>For families</h2>
                <p>
                  Search participating providers by service and state, read what
                  each offers, and contact them directly. Verify licensure,
                  success-rate reporting and insurance with each provider.
                </p>
              </section>
              <section id="s2">
                <h2>For providers</h2>
                <ul>
                  <li>Free listing after credential verification.</li>
                  <li>Patients using FutureFamilyAI can find you.</li>
                  <li>
                    No pay-to-rank: listing order follows published criteria.
                  </li>
                  <li>Update your profile any time.</li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>No partner fees. Our care team handles patient setup.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/partners/join-referral-network"
                >
                  Join the Partner Network — No Fees
                </Link>
              </div>
              <section id="s3">
                <h2>Our listing standards</h2>
                <p>
                  We publish eligibility criteria, verification standards,
                  ranking policy and any commercial relationships, including
                  affiliated brands in the Surrogacy4All network.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      How do I find a surrogacy agency or IVF clinic near me?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Use the directory search to filter by service and state,
                        then contact providers directly and verify credentials.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Is the directory free?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Yes. Listing is free for verified partners and searching
                        is free for families.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does a listing mean FutureFamilyAI endorses the provider?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        No. Listing means the provider met our published
                        criteria; it is not an endorsement of outcomes.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Are affiliated brands listed?</summary>
                    <div className="ffh-ans">
                      <p>
                        Yes, and they are clearly labeled as affiliated with the
                        Surrogacy4All network.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How are providers ordered?</summary>
                    <div className="ffh-ans">
                      <p>
                        By published, non-paid criteria such as service match
                        and location.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How do I join?</summary>
                    <div className="ffh-ans">
                      <p>
                        Complete the partner application; we verify credentials
                        before publishing your listing.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/partners/join-referral-network"
                  >
                    Join the Partner Network — No Fees
                  </Link>
                  <Link
                    className="ffh-btn ffh-ghost"
                    to="/contact-us?type=physician"
                  >
                    Request a Clinical Demo
                  </Link>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">RG</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Rashmi Gulati, MD</h3>
                  <p>
                    Medical Director, Patients Medical. Dr. Rashmi Gulati, MD,
                    is Medical Director of Patients Medical, a Manhattan
                    practice founded in 1974. She leads FutureFamilyAI&apos;s
                    physician and care-team content and medically reviews every
                    page on this site.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/partners">For IVF Clinics &amp; Agencies →</Link>
                  <Link to="/partners/join-referral-network">
                    Join Referral Network →
                  </Link>
                  <Link to="/partners/ivf-clinic-partnership">
                    IVF Clinic Partnership →
                  </Link>
                  <Link to="/partners/surrogacy-agency-partnership">
                    Surrogacy Agency Partnership →
                  </Link>
                  <Link to="/partners/no-fee-directory-faq">
                    No-Fee Directory FAQ →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.surrogacy4all.com">
                    https://www.surrogacy4all.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">For families</a>
                  </li>
                  <li>
                    <a href="#s2">For providers</a>
                  </li>
                  <li>
                    <a href="#s3">Our listing standards</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Partner with FutureFamilyAI</b>
                <span>No fees. Free directory listing.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/partners/join-referral-network"
                >
                  Join the Partner Network — No Fees
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
